

window.addEventListener('load', function () {

  function windowSize() {
    windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
  }

  windowSize();

  /*=====================================
  =              Buttons               =
  =====================================*/

  if (windowWidth > 1025) {

    document.querySelectorAll(".button--primary, .Button--primary, .wholesale_form_section button.submit, .function_enquiry_form_section button.submit").forEach((button) => {
      button.addEventListener("pointermove", (e) => {

        const rect = button.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        gsap.to(button, {
          "--pointer-x": `${x}px`,
          "--pointer-y": `${y}px`,
          duration: 0.6,

        });

        gsap.to(button, {
          "--button-glow": "#fff",
          duration: 0.2,
        });
      });

    });

    document.querySelectorAll(".button--secondary").forEach((button) => {
      button.addEventListener("pointermove", (e) => {

        const rect = button.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        gsap.to(button, {
          "--pointer-x": `${x}px`,
          "--pointer-y": `${y}px`,
          duration: 0.6,

        });

        gsap.to(button, {
          "--button-glow": "#DADADA",
          duration: 0.2,
        });
      });

    });

    // add animation on new site
    const classList = [
      { parent: '.shopify-section .tec-banner-container', child: 'picture img' },
      { parent: '.shopify-section .image-with-text', child: 'picture img' },
      { parent: '.shopify-section .content-over-media', child: 'picture img' },
      { parent: '.shopify-section .section-text-image-repeat .item', child: 'picture img' },
      { parent: '.shopify-section .homepage_subscriptions_wrap', child: 'picture img' },
      { parent: '.shopify-section .slide_swiper .swiper-slide', child: 'picture img' },
      //{ parent: '.shopify-section .default-banner', child: 'picture img' },
      { parent: '.shopify-section .featured-blog-post', child: '.featured-blog-image img' },
      { parent: '.shopify-section .featured-blog-post', child: '.place-feature-image img' },
      { parent: '.shopify-section .banner', child: 'picture img' },
      { parent: '.shopify-section .slider-container', child: 'picture img' },
      { parent: '.shopify-section .article__image', child: '.img-thumb img' },
      { parent: '.shopify-section p', child: 'p img' },
      { parent: '.shopify-section .article-images-item', child: '.article-images-item img' },
      //{ parent: '.product_gallery_wrap .product_slide_wrap', child: 'img' },
      { parent: '.shopify-section .rich-text-right', child: 'img' },
    ];
    const heightMonitor = window.innerHeight;
    const heightMonitorPer4 = heightMonitor / 4;
    classList.forEach((item) => {
      const parents = document.querySelectorAll(item.parent);
      if (parents) {
        parents.forEach((parent) => {
          // calculate position
          var thisPositionFromTopMonitor = parent.getBoundingClientRect().top;
          var percentStart;
          if (thisPositionFromTopMonitor + heightMonitorPer4 > heightMonitor) {
            // Start the animation when section position in 3/4 monitor from top
            percentStart = 75;
          } else if (thisPositionFromTopMonitor < 0) {
            percentStart = -10;
          } else {
            percentStart = thisPositionFromTopMonitor / heightMonitor * 100 - 10;
          }
          const startPosition = "0% " + percentStart + '%';
          // end calculate position

          const childs = parent.querySelectorAll(item.child);
          childs.forEach((child) => {
            gsap.timeline({
              scrollTrigger: {
                trigger: parent,
                start: startPosition,
                end: "+=160%",
                scrub: true,
                markers: false
              }
            }).to(child, {
              scale: 1.15
            }, "<");

          });
        });
      }
    });

    // end

    /*=====================================
    =            Feature Text              =
    =====================================*/

    const FeatureText = gsap.utils.toArray('.FeatureText');
    FeatureText.forEach((FTS, i) => {
      let FeatureTextAnim = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "-10% 75%",
          end: "+=160%",
          scrub: true,
          markers: false,
        }
      });

      FeatureTextAnim.to(FTS.querySelector('.AspectRatio img'), {
        scale: 1.15,
      }, '<');

      let FeatureTextAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "-5% 75%",
          end: "top top",
          scrub: true,
          markers: false,
        }
      });

      FeatureTextAnim2.to(FTS.querySelector('.SectionHeader__Description'), {
        opacity: 1,
      }, '');

      FeatureTextAnim2.to(FTS.querySelector('.Link'), {
        opacity: 1,
      }, '');

      let FeatureTextAnim4 = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "top 60%",
          end: "top 30%",
          scrub: true,
          markers: false,
        }
      });

      FeatureTextAnim4.to(FTS.querySelector('.SectionHeader__Heading .loader_anim'), {
        height: 0,
      }, '');


      let FeatureTextAnim3 = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "20% 50%",
          end: "top top",
          scrub: true,
          markers: false,
        }
      });

      FeatureTextAnim3.to(FTS.querySelector('.SectionHeader__SubHeading'), {
        opacity: 1,
      }, '');

    });


    /*=====================================
    =            Image With Text              =
    =====================================*/

    const ImageWithText = gsap.utils.toArray('.image-with-text-animations');
    ImageWithText.forEach((FTS, i) => {
      // let ImageWithTextAnim = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: FTS,
      //     start: "-10% 75%",
      //     end: "+=160%",
      //     scrub: true,
      //     markers: false,
      //   }
      // });

      // ImageWithTextAnim.to(FTS.querySelector('.AspectRatio img'), {
      //   scale: 1.15,
      // }, '<');

      let ImageWithTextAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "-5% 75%",
          end: "top top",
          scrub: true,
          markers: false,
        }
      });

      ImageWithTextAnim2.to(FTS.querySelector('.SectionHeader__SubHeading'), {
        opacity: 1,
      }, '');

      ImageWithTextAnim2.to(FTS.querySelectorAll('.SectionHeader__Description'), {
        opacity: 1,
      }, '');

      if (FTS.querySelector('.homepage_subscriptions_filters ')) {
        ImageWithTextAnim2.to(FTS.querySelector('.homepage_subscriptions_filters'), {
          opacity: 1,
        }, '');
      }

      ImageWithTextAnim2.to(FTS.querySelector('.link'), {
        opacity: 1,
      }, '');

      let ImageWithTextAnimButtons = FTS.querySelectorAll('.button');
      ImageWithTextAnimButtons.forEach((ImageWithTextAnimButton) => {
        ImageWithTextAnim2.to(ImageWithTextAnimButton, {
          opacity: 1,
        }, '');
      });

      let ImageWithTextAnim4 = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "top 75%",
          end: "top 45%",
          scrub: true,
          markers: false,
        }
      });

      ImageWithTextAnim4.to(FTS.querySelector('.SectionHeader__Heading .loader_anim'), {
        height: 0,
      }, '');


      let ImageWithTextAnim3 = gsap.timeline({
        scrollTrigger: {
          trigger: FTS,
          start: "20% 50%",
          end: "top top",
          scrub: true,
          markers: false,
        }
      });

      ImageWithTextAnim3.to(FTS.querySelector('.SectionHeader__SubHeading'), {
        opacity: 1,
      }, '');

    });


    /*=====================================
    =        promo banner section          =
    =====================================*/

    const promoBannerSection = gsap.utils.toArray('.promo_banner_section');
    promoBannerSection.forEach((PBS, i) => {

      let promoBannerSection1 = gsap.timeline({
        scrollTrigger: {
          trigger: PBS,
          start: "-10% 75%",
          end: "+=160%",
          scrub: true,
          markers: false,
        }
      });

      promoBannerSection1.to(PBS.querySelector('.image_wrap img'), {
        scale: 1.15,
      }, '<');

      let promoBannerSection2 = gsap.timeline({
        scrollTrigger: {
          trigger: PBS,
          start: "-5% 65%",
          end: "top 30%",
          scrub: true,
          markers: false,
        }
      });

      promoBannerSection2.to(PBS.querySelector('.promo_banner_text'), {
        opacity: 1,
      }, '');

      promoBannerSection2.to(PBS.querySelector('.button'), {
        opacity: 1,
      }, '');

      promoBannerSection2.to(PBS.querySelector('.promo_banner_title .loader_anim'), {
        height: 0,
      }, '');


      let promoBannerSection3 = gsap.timeline({
        scrollTrigger: {
          trigger: PBS,
          start: "20% 65%",
          end: "top 30%",
          scrub: true,
          markers: false,
        }
      });

      promoBannerSection3.to(PBS.querySelector('.promo_banner_subtitle'), {
        opacity: 1,
      }, '');

    });


    /*=====================================
    =               footer                =
    =====================================*/

    let FooterLeft = document.querySelector('.Footer__Left');
    let FooterRight = document.querySelector('.Footer__Right');
    let FooterMenu = document.querySelector('.Footer__Menu');

    let FooterLeftAnim = gsap.timeline({
      scrollTrigger: {
        trigger: FooterLeft,
        start: "top 80%",
        end: "top 55%",
        scrub: true,
        markers: false,
      }
    });

    FooterLeftAnim.to(FooterLeft.querySelector('.ft_header'), {
      opacity: 1,
    });
    FooterLeftAnim.to(FooterLeft.querySelector('.ft_content'), {
      opacity: 1,
    }, "0.15");

    let FooterRightAnim = gsap.timeline({
      scrollTrigger: {
        trigger: FooterRight,
        start: "top 60%",
        end: "top 35%",
        scrub: true,
        markers: false,
      }
    });

    FooterRightAnim.to(FooterRight.querySelector('.ft_header'), {
      opacity: 1,
    })
    FooterRightAnim.to(FooterRight.querySelector('.ft_content'), {
      opacity: 1,
    }, "0.15");

    let FooterMenuAnim = gsap.timeline({
      scrollTrigger: {
        trigger: FooterMenu,
        start: "top 70%",
        end: "top 30%",
        scrub: true,
        markers: false,
      }
    });

    FooterMenuAnim.to(FooterMenu.querySelector('.animation_wrap'), {
      left: "100%"
    });



    /*=====================================
    =        Slides Show Sections         =
    =====================================*/

    const slideShow = gsap.utils.toArray('.shopify-section--slideshow:not(.slideshow_banner)');

    slideShow.forEach((SS, i) => {

      let promoBannerSection1 = gsap.timeline({
        scrollTrigger: {
          trigger: SS,
          start: "-10% 75%",
          end: "+=160%",
          scrub: true,
          markers: false,
        }
      });
      promoBannerSection1.to(SS.querySelectorAll('.Slideshow__Image'), {
        scale: 1.15,
      }, '<');


      let promoBannerSection2 = gsap.timeline({
        scrollTrigger: {
          trigger: SS,
          start: "top 45%",
          end: "top 5%",
          scrub: true,
          markers: false,
        }
      });
      promoBannerSection2.to(SS.querySelectorAll('.SectionHeader__Heading'), {
        y: 0,
      }, '<');


    });


    /*=====================================
    =      Heading Body Image Section      =
    =====================================*/

    const headingBodyImageSection = gsap.utils.toArray('.heading_body_image_section');

    headingBodyImageSection.forEach((HBIS, i) => {

      let headingBodyImageSectionAnim = gsap.timeline({
        scrollTrigger: {
          trigger: HBIS,
          start: "top 75%",
          end: "top 30%",
          scrub: true,
          markers: false,
        }
      });



      headingBodyImageSectionAnim.to(HBIS.querySelector('.hbis_title .loader_anim'), {
        height: 0,
      }, '');


      let headingBodyImageSectionAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: HBIS,
          start: "top 50%",
          end: "top 20%",
          scrub: true,
          markers: false,
        }
      });

      headingBodyImageSectionAnim2.to(HBIS.querySelector('.hbis_subtitle'), {
        opacity: 1,
      }, '');


      let headingBodyImageSectionAnim3 = gsap.timeline({
        scrollTrigger: {
          trigger: HBIS,
          start: "top 30%",
          end: "top 10%",
          scrub: true,
          markers: false,
        }
      });

      headingBodyImageSectionAnim2.to(HBIS.querySelector('.right_wysiwyg_wrap'), {
        opacity: 1,
      }, '');

      headingBodyImageSectionAnim2.to(HBIS.querySelector('.right_side img'), {
        scale: 1.15,
      }, '<');

      headingBodyImageSectionAnim2.to(HBIS.querySelectorAll('.image_wrap img'), {
        scale: 1.15,
      }, '<');
      headingBodyImageSectionAnim3.to(HBIS.querySelector('.button'), {
        opacity: 1,
      }, '');

    });



    /*=====================================
    =               Relitems              =
    =====================================*/

    const relitems = gsap.utils.toArray('.relitems');

    relitems.forEach((relit, i) => {

      let relitemsAnim = gsap.timeline({
        scrollTrigger: {
          trigger: relit,
          start: "top 80%",
          end: "top 50%",
          scrub: true,
          markers: false,
        }
      });

      relitemsAnim.to(relit.querySelector('.relitems__body .animation_wrap'), {
        left: "100%"
      }, '');

      let relitemsAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: relit,
          start: "top 65%",
          end: "top 45%",
          scrub: true,
          markers: false,
        }
      });

      relitemsAnim2.to(relit.querySelector('.relitems__title .loader_anim'), {
        height: "0px"
      }, '');
    });

    /*=====================================
    =               Blog post              =
    =====================================*/

    const blogPosts = gsap.utils.toArray('.section-blog-posts');

    blogPosts.forEach((relit, i) => {

      let blogPostsAnim = gsap.timeline({
        scrollTrigger: {
          trigger: relit,
          start: "top 50%",
          end: "top 20%",
          scrub: true,
          markers: false,
        }
      });

      blogPostsAnim.to(relit.querySelector('.section-blog-posts .animation_wrap'), {
        left: "100%"
      }, '');

      let blogPostsAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: relit,
          start: "top 65%",
          end: "top 45%",
          scrub: true,
          markers: false,
        }
      });

      blogPostsAnim2.to(relit.querySelector('.section-blog-posts .loader_anim'), {
        height: "0px"
      }, '');
    });



    /*=====================================
    =        Banner Scroll Section       =
    =====================================*/

    let slideshowBanner = document.querySelector('.slideshow_banner');
    let nextElementSiblingBanner = document.querySelector('.slideshow_banner') !== null;

    if (nextElementSiblingBanner) {
      nextElementSiblingBanner = document.querySelector('.slideshow_banner').nextElementSibling;
      let slideshowBannerAnim1 = gsap.timeline({
        scrollTrigger: {
          trigger: nextElementSiblingBanner,
          start: "top 90%",
          end: "top 0%",
          scrub: true,
          markers: false,
        }
      });
      slideshowBannerAnim1.to(slideshowBanner.querySelectorAll('.Slideshow__ImageContainer img'), {
        scale: 1.15
      }, '');
      let slideshowBannerAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: nextElementSiblingBanner,
          start: "top 80%",
          end: "top 55%",
          scrub: true,
          markers: false,
        }
      });
      slideshowBannerAnim2.to(slideshowBanner.querySelectorAll('.heading_anim_wrap'), {
        opacity: 0,
        y: "-50px"
      }, '');

      gsap.timeline().fromTo(slideshowBanner.querySelectorAll('.heading_anim_wrap'), { opacity: 0, y: 100 }, { duration: 0.7, opacity: 1, y: 0, delay: 3 });

      let slideshowBannerAnim3 = gsap.timeline({
        scrollTrigger: {
          trigger: nextElementSiblingBanner,
          start: "top 65%",
          end: "top 0%",
          scrub: true,
          markers: false,
        }
      });
      slideshowBannerAnim3.to(slideshowBanner.querySelector('.banner_anim_section'), {
        opacity: 0.9
      }, '');
    }


    /*=====================================
    =         Faq Section Left          =
    =====================================*/

    const textElements = document.querySelectorAll('.shopify-section--faq .Container .fsl_subheading');
    for (const textElement of textElements) {
      const maxLength = 30;
      const lines = [];

      for (let i = 0; i < textElement.innerText.length; i += maxLength) {
        lines.push(textElement.innerText.substr(i, maxLength));
      }

      textElement.innerText = '';

      lines.forEach(line => {
        const divElement = document.createElement('div');
        divElement.innerHTML = "<div class='anim_wrap'>" + line + "</div>";
        textElement.appendChild(divElement);
      });
    }

    let shopifySectionFaq = gsap.utils.toArray('.shopify-section--faq');

    shopifySectionFaq.forEach((SSF, i) => {


      let shopifySectionFaqAnim = gsap.timeline({
        scrollTrigger: {
          trigger: SSF,
          start: "top 50%",
          end: "top 30%",
          scrub: true,
          markers: false,
        }
      });

      shopifySectionFaqAnim.to(SSF.querySelector('.fsl_header'), {
        opacity: 1,
      }, '');


      let shopifySectionFaqAnim1 = gsap.timeline({
        scrollTrigger: {
          trigger: SSF,
          start: "top 50%",
          end: "top 20%",
          scrub: true,
          markers: false,
        }
      });

      shopifySectionFaqAnim1.to(SSF.querySelector('.faq_anim_wrap'), {
        top: "100%",
      }, '');


      let shopifySectionFaqAnim2 = gsap.timeline({
        scrollTrigger: {
          trigger: SSF,
          start: "top 60%",
          end: "top 45%",
          scrub: true,
          markers: false,
        }
      });

      shopifySectionFaqAnim2.to(SSF.querySelectorAll('.anim_wrap'), {
        y: 0,
      }, '');

    });

  }

  ScrollTrigger.refresh();
  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
  });

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.contentBoxSize.length) {
        ScrollTrigger.refresh();
      }
    }
  });

  resizeObserver.observe(document.body);

  /*=====================================
  =         home page animations        =
  =====================================*/

  //loader

  // let loaderLogoWrap = document.querySelector('.loader_logo_wrap');
  // let loaderSecondText = document.querySelector('.loader_second_text');
  // let homeLoader = document.querySelector('.home_loader');
  // let slideshowBanner = document.querySelector('.slideshow_banner');
  // let hpHeader = document.querySelector('.shopify-section--header');
  // let announcementWrap = document.querySelector('.announcement_wrap');
  // let notificationsBar = document.querySelector('.template-index .notifications-bar');

  // gsap.timeline().to(loaderLogoWrap, { duration: 0.5, opacity: 1 })
  //   .to(loaderLogoWrap, { duration: 0.5, opacity: 0 })
  //   .to(loaderSecondText, { duration: 0.5, opacity: 1 })
  //   .to(loaderSecondText, { duration: 0.5, opacity: 0, y: -50, ease: "none" })
  //   .to(homeLoader, { duration: 0.5, y: "100%" })
  //   .to(slideshowBanner, { duration: 0.5, scale: 1 }, '<')
  //   .to(hpHeader, { duration: 0.5, opacity: 1 })
  //   .to(notificationsBar, { duration: 0.5, opacity: 1 });

  // if (document.querySelector('.template-index #main')) {
  //   gsap.to(announcementWrap, { duration: 0.5, opacity: 1, delay: 5, ease: "power2.inOut" });
  // } else {
  //   gsap.to(announcementWrap, { duration: 0.5, opacity: 1, delay: 0.3, ease: "power2.inOut" });
  // }
});

window.addEventListener('DOMContentLoaded', function () {
  ////scroll anim
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!entry.target.getAttribute('data-anim')) {
          entry.target.setAttribute('data-anim', 'done');
          entry.target.classList.add('anim_start');
        }
      }
    });
  });
  const elements = document.querySelectorAll('.text_slide_in, .text_slide_in_2, .anim_slide_down, .element_anim, .line_anim, .gradient_anim');
  elements.forEach(element => {
    observer.observe(element);
  });
  ////end of scroll anim

  /*=====================================
    =           Banner Heading            =
    =====================================*/
  let HeaderTextWrap = document.querySelectorAll('.banner .banner-heading');
  let HeaderTextAnimWrap = document.querySelectorAll('.banner .banner-heading .anim_wrap');
  gsap.timeline().to(HeaderTextWrap, { duration: 0.3, opacity: 1 })
    .to(HeaderTextAnimWrap, { duration: 0.2, y: 0 })
});
